import {generatePath} from 'react-router-dom'

import i18n from 'i18n'
import {TokenInfo, elementIds} from 'constData'
import routes from 'routes'
import {ReactComponent as PurchaseLinkIcon} from 'images/navigation/purchase-link-icon.svg'
import {ReactComponent as WalletLinkIcon} from 'images/navigation/wallet-link-icon.svg'
import {ReactComponent as PricesLinkIcon} from 'images/navigation/prices-link-icon.svg'
import {ReactComponent as ProfileIcon} from 'images/navigation/profile-icon.svg'

export const hideNavItems = false

const packagesOptions = [
  {
    id: elementIds.navigation.dropdownItems.packages.vimePurchase,
    text: 'VIME Packages',
    iconBefore: WalletLinkIcon,
    link: routes.vimePurchase.path,
  },
  // {
  //   id: elementIds.navigation.dropdownItems.packages.vimeMbasePurchase,
  //   text: 'Veelive Packages',
  //   iconBefore: WalletLinkIcon,
  //   link: routes.vimeMbasePurchase.path,
  // },
  {
    id: elementIds.navigation.dropdownItems.packages.starPackages,
    text: 'Star Packages',
    iconBefore: WalletLinkIcon,
    link: routes.globalMarketingPlan.path,
  },
  {
    id: elementIds.navigation.dropdownItems.packages.metaverseLand,
    text: 'Land Share',
    iconBefore: WalletLinkIcon,
    link: `${routes.metaverseLand.path}/${routes.metaverseLand.puchasedMetaverseLand.path}`,
  },
  {
    id: elementIds.navigation.dropdownItems.packages.legacyProducts,
    text: 'Old Purchased Packages',
    iconBefore: WalletLinkIcon,
    link: routes.legacyProducts.path,
  },
]

const buyOptions = [
  {
    id: elementIds.navigation.dropdownItems.buyItems.creditCardLink,
    text: 'Buy with your credit card',
    iconBefore: WalletLinkIcon,
    link: 'https://www.minebase.team/creditcard',
    extranal: true,
  } /* ,
  {
    id: elementIds.navigation.dropdownItems.buyItems.purchaseMinebase,
    text: 'Buy minebase tokens',
    iconBefore: WalletLinkIcon,
    link: `${generatePath(routes.wallet.info.path, {
      id: TokenInfo.MBASE.urlId,
    })}?type=purchaseToken`,
  } */,
  {
    id: elementIds.navigation.dropdownItems.buyItems.purchaseXon,
    text: 'Buy xon tokens',
    iconBefore: WalletLinkIcon,
    link: `${generatePath(routes.wallet.info.path, {
      id: TokenInfo.XON.urlId,
    })}?type=purchaseToken`,
  },
  {
    id: elementIds.navigation.dropdownItems.packages.vimeMbasePurchase,
    text: 'Buy Products with Minebase Tokens',
    iconBefore: WalletLinkIcon,
    link: routes.vimeMbasePurchase.path,
  },
  {
    id: elementIds.navigation.dropdownItems.packages.characterPurchase,
    text: 'Veelive Character with Minebase Tokens',
    iconBefore: WalletLinkIcon,
    link: `${routes.characterPurchase.path}/${routes.characterPurchase.characterPurchased.path}`,
  },
]

const ctpOptions = [
  {
    id: elementIds.navigation.dropdownItems.ctpItems.mbaseToken,
    text: 'Mbase Token',
    iconBefore: WalletLinkIcon,
    link: `${generatePath(routes.tokenProductions.path, {
      id: TokenInfo.MBASE.urlId,
    })}`,
  },
  {
    id: elementIds.navigation.dropdownItems.ctpItems.xonToken,
    text: 'XON Token',
    iconBefore: WalletLinkIcon,
    link: `${generatePath(routes.tokenProductions.path, {
      id: TokenInfo.XON.urlId,
    })}`,
  },
]

const topNavFillItems = () =>
  Object.freeze([
    {
      id: elementIds.navigation.items.dashboard,
      title: i18n.t('navigation.items.purchase', {token: TokenInfo.V999.tokenName}),
      Icon: PurchaseLinkIcon,
      link: routes.home.path,
    },
    {
      id: elementIds.navigation.items.wallet,
      title: i18n.t('navigation.items.wallet'),
      Icon: WalletLinkIcon,
      link: routes.wallet.path,
    },
    {
      id: elementIds.navigation.items.ctp,
      title: i18n.t('navigation.items.tokenProductions'),
      Icon: PricesLinkIcon,
      dropdownNode: true,
      dropdownOptions: ctpOptions,
    },
    {
      id: elementIds.navigation.items.interconnect,
      title: i18n.t('navigation.items.interConnectWallet'),
      Icon: WalletLinkIcon,
      link: routes.interconnectWallets.path,
    },
    {
      id: elementIds.navigation.items.buy,
      title: i18n.t('navigation.items.purchaseToken'),
      Icon: WalletLinkIcon,
      dropdownNode: true,
      dropdownOptions: buyOptions,
    },
    {
      id: elementIds.navigation.items.packages,
      title: i18n.t('Packages'),
      Icon: WalletLinkIcon,
      dropdownNode: true,
      dropdownOptions: packagesOptions,
    },
    {
      id: elementIds.navigation.items.profile2,
      title: i18n.t('navigation.items.profile'),
      Icon: ProfileIcon,
      link: routes.profile.path,
    },
  ])

const mobileNavFillItems = () =>
  Object.freeze([
    {
      id: elementIds.navigation.items.dashboard,
      title: i18n.t('navigation.items.purchase', {token: TokenInfo.V999.tokenName}),
      Icon: PurchaseLinkIcon,
      link: routes.home.path,
    },
    {
      id: elementIds.navigation.items.wallet,
      title: i18n.t('navigation.items.wallet'),
      Icon: WalletLinkIcon,
      link: routes.wallet.path,
    },
    {
      id: elementIds.navigation.dropdownItems.ctpItems.mbaseToken,
      title: i18n.t('navigation.items.mbaseTokenProductions'),
      Icon: PricesLinkIcon,
      link: `${generatePath(routes.tokenProductions.path, {
        id: TokenInfo.MBASE.urlId,
      })}`,
    },
    {
      id: elementIds.navigation.dropdownItems.ctpItems.xonToken,
      title: i18n.t('navigation.items.xonTokenProductions'),
      Icon: PricesLinkIcon,
      link: `${generatePath(routes.tokenProductions.path, {
        id: TokenInfo.XON.urlId,
      })}`,
    },
    {
      id: elementIds.navigation.items.interconnect,
      title: i18n.t('navigation.items.interConnectWallet'),
      Icon: WalletLinkIcon,
      link: routes.interconnectWallets.path,
    },
    {
      id: elementIds.navigation.dropdownItems.buyItems.purchaseMinebase,
      title: i18n.t('navigation.items.purchaseMbaseToken'),
      Icon: WalletLinkIcon,
      link: `${generatePath(routes.wallet.info.path, {
        id: TokenInfo.MBASE.urlId,
      })}?type=purchaseToken`,
    },
    {
      id: elementIds.navigation.dropdownItems.buyItems.purchaseXon,
      title: i18n.t('navigation.items.purchaseXonToken'),
      Icon: WalletLinkIcon,
      link: `${generatePath(routes.wallet.info.path, {
        id: TokenInfo.XON.urlId,
      })}?type=purchaseToken`,
    },
    {
      id: elementIds.navigation.dropdownItems.packages.starPackages,
      title: i18n.t('navigation.items.globalMarketingPlan'),
      Icon: WalletLinkIcon,
      link: routes.globalMarketingPlan.path,
    },
    {
      id: elementIds.navigation.dropdownItems.packages.vimePurchase,
      title: i18n.t('navigation.items.vimePurchase'),
      Icon: WalletLinkIcon,
      link: routes.vimePurchase.path,
    },
    {
      id: elementIds.navigation.dropdownItems.packages.vimeMbasePurchase,
      title: i18n.t('navigation.items.vimeMbasePurchase'),
      Icon: WalletLinkIcon,
      link: routes.vimeMbasePurchase.path,
    },
    {
      id: elementIds.navigation.dropdownItems.packages.characterPurchase,
      title: i18n.t('navigation.items.characterPurchase'),
      Icon: WalletLinkIcon,
      link: `${routes.characterPurchase.path}/${routes.characterPurchase.characterPurchased.path}`,
    },
    {
      id: elementIds.navigation.dropdownItems.packages.metaverseLand,
      title: i18n.t('navigation.items.landShare'),
      Icon: WalletLinkIcon,
      link: `${routes.metaverseLand.path}/${routes.metaverseLand.puchasedMetaverseLand.path}`,
    },
    {
      id: elementIds.navigation.dropdownItems.packages.legacyProducts,
      title: i18n.t('navigation.items.legacyProducts'),
      Icon: WalletLinkIcon,
      link: routes.legacyProducts.path,
    },
    {
      id: elementIds.navigation.items.profile2,
      title: i18n.t('navigation.items.profile'),
      Icon: ProfileIcon,
      link: routes.profile.path,
    },
  ])

let topNavItems = topNavFillItems()
let mobileNavItems = mobileNavFillItems()

i18n.on('languageChanged init', () => {
  topNavItems = topNavFillItems()
  mobileNavItems = mobileNavFillItems()
})

export {topNavItems, mobileNavItems}
